<template>
  <div v-if="tableDisplay == 'routes'">
    <v-row style="margin-top: -83px">
      <v-spacer></v-spacer>
      <v-col cols="3" class="text-right"> 
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details>
          <template slot="append-outer">
            <date-range-picker @clicked="onSelectDates"/>
          </template>
        </v-text-field>
      </v-col>
      <!-- <v-col cols="12" class="text-right">
        <v-btn
          color="primary"
          dark
          rounded
          small
          class="mx-2"
          @click="dialog = true"
        >
          Create Document Type
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col> -->
    </v-row>
    <v-row >
      <v-col class="pb-0 pt-0">
        <v-row>
        <span class="ma-2 pt-2 pl-2">
          Priority: 
        </span>
        <v-chip-group
          mandatory
        >
          <v-chip class="ma-2"
            filter
            color="secondary"
            text-color="white"
            @click="urgencyFilter('All')"
          >
            All
            <v-avatar
              right
              class="secondary darken-4"
            >
              {{getTotalRoutes}}
            </v-avatar>
          </v-chip>
          <v-chip class="ma-2"
            filter
            color="red"
            text-color="white"
            @click="urgencyFilter('High')"
          >
            High
            <v-avatar
              right
              class="red darken-4"
            >
              {{getTotalHighUrgencyRoute}}
            </v-avatar>
          </v-chip>
          <v-chip class="ma-2"
            filter
            color="blue"
            text-color="white"
            @click="urgencyFilter('Moderate')"
          >
            Moderate
            <v-avatar
              right
              class="blue darken-4"
            >
              {{getTotalModerateUrgencyRoutes}}
            </v-avatar>
          </v-chip>
        </v-chip-group>
        <v-divider class="ma-2" vertical></v-divider>
        <v-chip-group
          v-model="selectedStatus"
        >
          <v-chip class="ma-2"
            filter
            color="grey"
            text-color="white"
            value="Idle"
          >
            Idle
            <v-avatar
              right
              class="grey darken-2"
            >
              {{getTotalIdle}}
            </v-avatar>
          </v-chip>
          <v-chip class="ma-2"
            filter
            color="red"
            text-color="white"
            value="Overdue"
          >
            Overdue
            <v-avatar
              right
              class="red darken-4"
            >
              {{getTotalOverdue}}
            </v-avatar>
          </v-chip>
          <v-chip class="ma-2"
            filter
            color="orange"
            text-color="white"
            value="Almost Due"
          >
            Almost Due
            <v-avatar
              right
              class="orange darken-4"
            >
              {{getTotalAlmostDue}}
            </v-avatar>
          </v-chip>
        </v-chip-group>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="selected.length > 0">
        <v-app-bar color="grey darken-3" dense dark>
          <v-toolbar-title class="overline"
            >{{ selected.length }} selected</v-toolbar-title
          >
          <v-divider class="mx-4" vertical></v-divider>
          <v-btn
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="editItem()"
            >Edit</v-btn
          >
          <v-btn
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="deleteItem(item.id)"
            >Delete</v-btn
          >
          <v-btn
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="seeTransactionLog()"
            >Route Tracking Details</v-btn
          >
        </v-app-bar>
      </v-col>
    </v-row>
    <v-row class="mb-n6" v-show="showRouteSuccess">
      <v-col cols="12">
        <v-alert dense text type="success" dismissible
          >Saved Route Record</v-alert
        >
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col>
        <v-data-table
          show-select
          :search="search"
          v-model="selected"
          :single-select="false"
          :headers="headers"
          :items="allRoutes"
          :items-per-page="10"
          class="elevation-2"
          item-key="id"
          :loading="isFetching || isLoading"
          loading-text="Loading... Please wait"
        >
          <!-- <template v-slot:[`item.overdue_status`]="{ item }">
            <v-icon
              :color="
                item.overdue_status ? 'red' : '' || item.isWarned ? 'yellow darken-2' : '' "
              >mdi-circle</v-icon
            >
          </template> -->
          <template v-slot:[`item.subject`]="{ item }">
            <a class="goto" :href="item.link">
              {{ item.subject }}
            </a>
          </template>
          <template v-slot:[`item.due`]="{ item }">
            <div v-if="item.due === 'No due date'" class="indigo--text">
              {{ item.due }}
            </div>
            <div v-else>
              {{ item.due }}
            </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              small
              pill
              :color="item.status == 'Pending' ? '' : 'red darken-3'"
              text-color="white"
              v-if="item.status != 'Done' && item.overdue_status == true"
            >
              {{ (item.status = "Overdue") }}
            </v-chip>
            <v-chip
              small
              pill
              :color="item.status == 'Pending' ? 'grey darken-2' : ''"
              text-color="white"
              v-if="
                item.isWarned != true &&
                  item.status != 'Done' &&
                  item.overdue_status != true
              "
            >
              {{ item.status }}
            </v-chip>
            <v-chip
              small
              pill
              color="green darken-1"
              text-color="white"
              v-else-if="item.status == 'Done' && item.overdue_status != true"
            >
              {{ item.status }}
            </v-chip>
            <v-chip
              v-else-if="item.overdue_status == true && item.status == 'Done'"
              small
              pill
              color="green"
              text-color="white"
            >
              {{ item.status }}
            </v-chip>
            <span v-else>-</span>
          </template>

          <template v-slot:[`item.date_completed`]="{ item }">
            <span v-if="!item.date_completed">
              -
            </span>
            <span v-else style="text-align: center">
              {{ formatDate(item.date_completed) }}
            </span>
          </template>
          <template v-slot:[`item.dateCreated`]="{ item }">
            <span v-if="!item.dateCreated">
              -
            </span>
            <span v-else style="text-align: center">
              {{ formatDate(item.dateCreated) }}
            </span>
          </template>

          <template v-slot:[`item.durations`]="{ item }">
            <span v-if="item.status == 'Done'" style="text-align: center">
              -
            </span>
            <DateCountdown
              v-else
              :routeId="item.id"
              :routeType="'mainroute'"
              :date="item.durations"
              :isWarned="item.isWarned"
              :accessRoutesList="'list'"
              :showCaption="false"
              :currentStatus="computedStatusColor"
              :showDate="false"
              :onlyHeader="false"
              :isOverdued="item.overdue_status"
              @emitWarning="routeWarning"
            />
          </template>
          <template v-slot:[`item.isIdle`]="{ item }">
            <v-chip
              small
              pill
              :color="`${item.isIdle ? 'secondary darken-1' : 'primary darken-1'}`"
              text-color="white">
              {{ item.isIdle ? "Idle" : "Active"}}  
            </v-chip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :timeout="timeout" class="pb-10">
      This action requires you to select only one route

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- <RouteModalCreate :dialog="route_dialog" @closeDialog="closeRouteDialog" /> -->

    <UpdateRouteDetails
      :dialog="update_details_dialog"
      :selectedRoute="selected_update_item"
      @closeDialog="closeRouteUpdateModal"
    />

    <RouteLogTrackModal
      :dialog="route_log_dialog"
      :routeId="selected_log_id"
      :routeType="'mainroute'"
      @closeDialog="closeLog"
    />
  </div>
</template>

<script>
  import { mapGetters, mapState, mapActions } from "vuex";
  // import RouteModalCreate from "../RouteCreateModal";
  import DateCountdown from "../DateCountdown";
  import UpdateRouteDetails from "../UpdateRouteDetails";
  import RouteLogTrackModal from "./RouteLogTrackModal";
  import moment from "moment";
  import _ from "lodash";
  import DateRangePicker from "./DateFilter.vue"
  export default {
    name: "RoutesTable",
    props: {
      tableDisplay: String,
      // search: String,
      // dateRange: Object,
      isFetching: Boolean,
    },
    components: {
      // RouteModalCreate,
      DateCountdown,
      UpdateRouteDetails,
      RouteLogTrackModal,
      DateRangePicker
    },
    data() {
      return {
        dateRange: {
          startDate: "",
          endDate: ""
        },
        search: "",
        route_dialog: false,
        urgency: "All",
        update_details_dialog: false,
        headers: [
          { text: "Subject", value: "subject" },
          { text: "Date Created", value: "dateCreated" },
          { text: "Due Date", value: "due" },
          { text: "Date Completed", value: "date_completed", align: "center" },
          { text: "Status", value: "status", sortable: true },
          {
            text: "Duration",
            value: "durations",
            sortable: true,
            align: "center",
          },
          { text: "Idle Status", value: "isIdle", sortable: true, align: "center"}
        ],
        sortBy: "durations",
        sortDesc: false,
        items: [],
        selected: [],
        showRouteSuccess: false,
        overall_status_color: "",
        overdue_status_color: "",
        color_list: ["indigo lighten-1"],
        selected_update_item: null,
        snackbar: false,
        timeout: 5000,
        route_log_dialog: false,
        selected_log_id: null,
        options: {
          page: 1,
          itemsPerPage: 10,
          mustSort: true,
          groupBy: [],
          sortDesc: [false],
        },
        isLoading: false,
        durationStatus: '',
        selectedStatus: null
      };
    },
    methods: {
      ...mapActions(["fetchFilteredRoutes"]),
      editItem() {
        if (this.selected.length > 1) {
          this.snackbar = true;
        } else {
          this.selected_update_item = this.selected[0];
          this.update_details_dialog = true;
          console.log(this.selected[0]);
        }
      },
      deleteItem(item) {
        const index = this.desserts.indexOf(item);
        confirm("Are you sure you want to delete this item?") &&
          this.desserts.splice(index, 1);
      },
      closeRouteDialog(val) {
        if (val) this.showRouteSuccess = true;
        this.route_dialog = false;
        this.selected = [];
      },
      getColor(status) {
        if (status == "Pending") {
          this.overall_status_color = "indigo lighten-2";
        } else if (status == "Overdue") {
          this.overall_status_color = "red";
        } else if (status == "Done") {
          this.overall_status_color = "green";
        } else {
          this.overall_status_color = "";
        }
      },
      getOverdueColor(status) {
        if (status) return "red darken-1";
        else return "";
      },
      routeWarning(val) {
        if (val) this.overdue_status_color = "yellow lighten-4";
      },
      closeRouteUpdateModal() {
        this.update_details_dialog = false;
      },
      seeTransactionLog() {
        if (this.selected.length > 1) {
          this.snackbar = true;
        } else {
          this.selected_log_id = this.selected[0].id;
          this.route_log_dialog = true;
        }
      },
      closeLog() {
        this.route_log_dialog = false;
      },
      formatDate(date) {
        return moment(date).format("LLL");
      },
      urgencyFilter(val) {
        this.urgency = val
        this.fetch();
      },
      statusFilter(val){
        this.durationStatus = val
        this.fetch();
      },
      onSelectDates(val){
        this.dateRange = val
        console.log(this.dateRange)
      },
      fetch: _.debounce(async function() {
        this.isLoading = true
        let payload = {
          durationStatus: this.durationStatus,
          urgency: this.urgency,
          search: this.search != "" ? this.search : "",
          dateRange:
            this.dateRange.startDate != "" && this.dateRange.endDate != ""
              ? this.dateRange
              : { startDate: "January 01 , 1680", endDate: moment() },
          itemsPerPage: 10,
        };
        console.log(payload);
        await this.fetchFilteredRoutes(payload).then(() => {
          this.isLoading = false
        });
      }, 500),
    },
    computed: {
      ...mapGetters(["allRoutes", "getTotalRoutes", "getTotalHighUrgencyRoute", "getTotalModerateUrgencyRoutes", "getTotalLowUrgencyRoutes", "getTotalIdle", "getTotalOverdue", "getTotalAlmostDue"]),
      ...mapState({
        loading: (state) => state.routes.loading,
      }),
      computedStatusColor: function() {
        var color = "";
        if (this.allRoutes.isWarned) {
          color = "yellow";
        }
        return color;
      },
    },
    watch: {
      dateRange: {
        handler() {
          this.fetch();
        },
      },
      search: {
        handler() {
          this.fetch();
        },
      },
      selectedStatus: {
        handler() {
          this.statusFilter(this.selectedStatus ? this.selectedStatus : 'None')
        }
      }
    },
  };
</script>

<style></style>
